<template>
    <div class="videoMessage">
        <custom-video-player
            class="video-player-box"
            ref="videoPlayer"
            :src="videoSrc()"
            :max-width="400"
            :max-height="300"
            :playback-rates="[0.7, 1.0, 1.5, 2.0]"
            :muted="false"
            :timestamp="displayTimestamp"
            :timestamp-tooltip="timestampTooltip"
        />
    </div>
</template>

<script>
import CustomVideoPlayer from "@/components/common/CustomVideoPlayer.vue";
import moment from "moment";

export default {
    name: "VideoMessage",
    components: {
        CustomVideoPlayer,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        message: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {};
    },
    computed: {
        displayTimestamp() {
            return this.formattedTimestamp();
        },
        timestampTooltip() {
            const timestamp =
                this.message?.raw?.createdDate ||
                this.message?.timestamp ||
                this.message?.createdAt ||
                this.message?.time ||
                this.data?.createdDate ||
                this.data?.createdAt ||
                this.data?.timestamp ||
                this.data?.time;
            if (!timestamp) return "";
            return moment(timestamp).format("DD.MM.YYYY HH:mm");
        },
    },
    methods: {
        videoSrc() {
            const asset = this.data.asset;
            const path = asset?.path || "";
            if (path === "") return null;
            const isWhatsapp = path.indexOf("whatsapp") !== -1;
            const isInstagram = path.indexOf("instagram") !== -1;
            const isMessenger = path.indexOf("messenger") !== -1;
            const isTelegram = path.indexOf("telegram") !== -1;
            const isFacebook = path.indexOf("facebook") !== -1;
            const isTable = path.indexOf("tables/attachments") !== -1;
            const isUnipile = path.indexOf("unipile") !== -1;
            const isChat = path.indexOf("chat") !== -1;
            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger || isFacebook || isTable || isUnipile || isChat
                    ? `https://static.supsis.live/${asset.path}`
                    : asset.v2Format && asset.cdnUrl
                    ? asset.cdnUrl
                    : `https://static.supsis.live/${asset.path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            return src;
        },
        formattedTimestamp() {
            const timestamp =
                this.message?.raw?.createdDate ||
                this.message?.timestamp ||
                this.message?.createdAt ||
                this.message?.time ||
                this.data?.createdDate ||
                this.data?.createdAt ||
                this.data?.timestamp ||
                this.data?.time;
            if (!timestamp) return "";
            return moment(timestamp).format("HH:mm");
        },
    },
};
</script>

<style lang="scss" scoped>
.videoMessage {
    display: inline-block;

    .video-player-box {
        max-width: 400px;
        max-height: 300px;
    }
}
</style>
